$(function() {
    "use strict";

    $(document).on('focus', '.search-form__input', function() {
        $(this).siblings('.search-form__droplet')
            .addClass('search-form__droplet_shown');
    });

    $(document).on('click', function() {
       $('.search-form__droplet_shown')
           .removeClass('search-form__droplet_shown');
    });

    $(document).on('click', '.search-form', function(event) {
        event.stopPropagation()
    });
});